import React from "react";
import "./App.css";

import { Redirect, Route, BrowserRouter as Router } from "react-router-dom";

import LandingPage from "./components/pages/LandingPage";
import Gallery from "./components/pages/Gallery";
import Navigation from "./components/containers/navigation/Navigation";

const landing = "/";
const gallery = "/gallery";

const App = () => {
  return (
    <div>
      <Router>
        <div>
          <Navigation />

          <Route exact path={landing} component={LandingPage} />
          <Route exact path="/gallery" component={Gallery} />

          {document.location.pathname === gallery ||
          document.location.hash !== "" ? null : (
            <Route path="*">
              <Redirect to={landing} />
            </Route>
          )}
        </div>
      </Router>
    </div>
  );
};

export default App;
